import { GeoLocation } from '@core/Areas/VenueMode/Store'

export enum ValidateCoordinatesEnum {
  Success = '',
  MissingCoordinates = 'Missing Coordinates',
  InvalidCoordinates = 'Invalid Coordinates',
  LowAccuracy = 'Low Accuracy',
}

export function validateCoordinates(geoLocation: GeoLocation) {
  if (!geoLocation.latitude || !geoLocation.longitude) {
    // in theory we should never receive a missing lat/long, but validated here to make downstream processing simpler
    return ValidateCoordinatesEnum.MissingCoordinates
  }

  if (
    geoLocation.latitude < -90 ||
    geoLocation.latitude > 90 ||
    geoLocation.longitude > 180 ||
    geoLocation.longitude < -180
  ) {
    // in theory we should never receive an invalid latitude/longitude, but validated here to make downstream processing simpler
    return ValidateCoordinatesEnum.InvalidCoordinates
  }

  if (geoLocation.accuracy && geoLocation.accuracy > 20) {
    // GPS accuracy is too low to support reliable location determination, e.g. cell tower reading
    return ValidateCoordinatesEnum.LowAccuracy
  }

  return ValidateCoordinatesEnum.Success
}
